import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

const Marquee = () => {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/scrolling`)
      .then(res => res.json())
      .then(data => setUpdates(data))
      .catch(err => console.error('Error fetching scrolling updates:', err));
  }, []);

  return (
    <div className="marquee">
      <marquee>
        {updates.map((item, index) => (
          <span key={item.id || index}>
            {item.content} {index < updates.length - 1 && ' | '}
          </span>
        ))}
      </marquee>
    </div>
  );
};

export default Marquee;